import { z } from 'zod'

import { SupplierBinding } from './supplier'

import { Pagination } from '@/types/app/request'
import { ManagerBinding } from '@/types/park/manager'
import { Category } from '@/types/shared/category'

/** Enum products status type. */
export const StatusProductList = z.enum(['ALL', 'ACTIVATED', 'DEACTIVATED'])

/** Nutriscore of the product. */
export const NutriScore = z.enum(['A', 'B', 'C', 'D', 'E'])

/** Product object returned by the API. */
export const Product = z.object({
    // Product
    id: z.number().positive(),
    name: z.string().min(1),
    client: ManagerBinding,
    supplier: SupplierBinding,
    category: Category,
    subcategory: Category,
    photo: z.string().url(),
    description: z.string().nullable(),
    ean: z.string().min(1),
    client_serial: z.string().min(1).nullable(),
    weight: z.number().positive(),
    volume: z.number().positive().nullable(),
    allergens: Category.array(),
    disabled: z.boolean(),

    // Commercial information
    tva: z.number().positive(),
    purchase_price: z.number().positive(),
    price: z.number().positive(),
    price_badge: z.number().positive().nullable(),
    price_mobileapp: z.number().positive().nullable(),
    valid_number_of_days: z.number().positive(),
    is_price_weight: z.boolean(),
    luncheon_vouchers: z.boolean(),

    // Instructions
    is_eligible_fridge_weight: z.boolean(),
    mass_measure_1: z.number().min(50).nullable(),
    mass_measure_2: z.number().min(50).nullable(),
    mass_measure_3: z.number().min(50).nullable(),
    mass_measure_4: z.number().min(50).nullable(),
    mass_measure_5: z.number().min(50).nullable(),
    needs_cooking: z.boolean(),
    cooking_time: z.number().positive().nullable(),
    cooking_temp: z.number().positive().nullable(),
    age_limit: z.boolean(),

    // Nutritional values
    energy_kj: z.number().positive().nullable(),
    energy_kcal: z.number().positive().nullable(),
    fats: z.number().nonnegative().nullable(),
    saturated_fats: z.number().nonnegative().nullable(),
    carbs: z.number().nonnegative().nullable(),
    sugars: z.number().nonnegative().nullable(),
    fibers: z.number().nonnegative().nullable(),
    proteins: z.number().nonnegative().nullable(),
    salt: z.number().nonnegative().nullable(),
    nutriscore: NutriScore.nullable(),
})

export type Product = z.infer<typeof Product>

export const ProductBinding = Product.pick({
    id: true,
    name: true,
})

export type ProductBinding = z.infer<typeof ProductBinding>

export const ProductsRequest = Pagination.extend({
    results: Product.array(),
})

export type ProductsRequest = z.infer<typeof ProductsRequest>
